import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const AlabamaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='alabama'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='AL_ZS'
				points='726.6 480.7 746.65 528.11 766.17 580.5 742.72 630.28 739.91 647.07 748.95 731.52 757.78 789.8 416.09 787.31 398.69 799.52 396.7 815.4 425.7 849.16 423.81 874.63 414.47 886.7 400.62 903.32 383.54 912.55 370.65 892.05 349.57 872.96 351.84 851.82 347.94 841.34 339.41 836.4 330.68 852.37 326.5 891.34 291.68 887.6 283.09 864.55 277.88 650.77 297.81 483.35 726.6 480.7'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'AL_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('AL_ZS')}
			/>
			<polygon
				id='AL_ZN'
				points='726.6 480.7 703.47 349.48 667.02 136.37 339.25 135.38 297.81 483.35 726.6 480.7'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'AL_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('AL_ZN')}
			/>
			<rect
				x='429.57'
				y='623.02'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M428.95,662.55l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M463.44,659.37c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect x='578.02' y='328.9' width='73.15' height='43.33' fill='none' className='shape' />
			<path
				d='M577.41,368.43l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M611.27,371.5l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='526.87 153.25 526.98 157.57 531.53 157.57 527.05 160.25 527.15 164.57 524.28 161.9 519.8 164.57 522.5 160.25 519.62 157.57 524.17 157.57 526.87 153.25'
				className='shape'
			/>
			<rect x='525.6' y='163.6' width='119.75' height='20' fill='none' className='shape' />
			<path
				d='M531.42,164.46l-1.31,6.82h7.44l1.3-6.82h2l-3.08,16.18h-1.99l1.44-7.6h-7.44l-1.43,7.6h-1.99l3.08-16.18h1.99Z'
				className='shape'
			/>
			<path
				d='M555.05,169.03l-1.56,8.23c-.25,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.06-.72-3.06-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M558.78,180.64l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M579.22,165.91l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M584.05,178.62c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M597.91,169.03l1,6.61c.18,1.32.33,2.21.37,2.85h.07c.25-.62.57-1.38,1.24-2.7l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M608.67,180.64l2.22-11.61h1.99l-2.22,11.61h-1.99ZM611.26,165.79c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.03.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M616.6,180.64l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M624.52,180.64l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M640.8,179.97c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM638.6,170.31c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='504.66 335.69 504.77 340.01 509.32 340.01 504.84 342.68 504.94 347 502.07 344.33 497.59 347 500.29 342.68 497.41 340.01 501.96 340.01 504.66 335.69'
				className='shape'
			/>
			<rect x='357.73' y='319.57' width='143.68' height='20' fill='none' className='shape' />
			<path
				d='M361.5,320.66c.99-.2,2.15-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM360.74,335c.51.08,1.09.11,1.64.11,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM362.22,327.3h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.93-2.22-.73,0-1.34.05-1.65.15l-1,5.25Z'
				className='shape'
			/>
			<path
				d='M373.26,336.61l2.22-11.61h1.99l-2.22,11.61h-1.99ZM375.85,321.76c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M381.18,336.61l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M391.22,336.61l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.04.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M413.03,336.61l2.22-11.61h1.99l-2.22,11.61h-1.99ZM415.62,321.76c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M420.95,336.61l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M436.29,339.25c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1.01-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM445.21,326.73c-.37-.18-1.09-.4-1.92-.4-2.91,0-4.91,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M451.19,336.61l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.81h-1.99Z'
				className='shape'
			/>
			<path
				d='M474.13,336.61c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM475.42,326.49c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M481.43,336.61l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.04.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<polygon
				points='565.66 522.01 565.77 526.34 570.32 526.34 565.84 529.01 565.94 533.33 563.07 530.66 558.59 533.33 561.29 529.01 558.41 526.34 562.96 526.34 565.66 522.01'
				className='shape'
			/>
			<rect x='412.9' y='505.9' width='149.51' height='20' fill='none' className='shape' />
			<path
				d='M427.2,522.94l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.4h-.05c-.34,1.5-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.19-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M445.87,515.9c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM436.94,518.36c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M449.68,522.94l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M470.11,508.21l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M474.83,525.58c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.72.81l-1.78,9.59c-.47,2.46-1.13,4.15-2.34,5.2-1.16,1.01-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM483.76,513.06c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M500.87,515.9c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM491.95,518.36c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M504.69,522.94l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.05c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.29,6.85h-1.95l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M534.87,522.28c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM532.67,512.62c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M539.8,522.94l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M552.87,511.33l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.25-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='665.82 496.81 665.92 501.14 670.47 501.14 665.99 503.81 666.1 508.13 663.22 505.46 658.74 508.13 661.44 503.81 658.57 501.14 663.11 501.14 665.82 496.81'
				className='shape'
			/>
			<rect x='650.81' y='511.33' width='84.54' height='20' fill='none' className='shape' />
			<path
				d='M654.84,523.26l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM660.27,521.67l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path
				d='M678.77,516.77l-1.57,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.04,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M687.62,511.33l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-2.99,0-.57.09-1.25.2-1.8l2.5-12.51h1.99ZM685.1,523.89c-.08.39-.15.85-.14,1.47.01,1.11.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.21-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M708.85,516.77l-1.56,8.23c-.25,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M712.57,528.38l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M722.6,528.38l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='349.02 806.03 349.13 810.36 353.67 810.36 349.19 813.03 349.3 817.35 346.42 814.68 341.94 817.35 344.65 813.03 341.77 810.36 346.32 810.36 349.02 806.03'
				className='shape'
			/>
			<rect x='290.61' y='784.16' width='81.61' height='20' fill='none' className='shape' />
			<path
				d='M304.91,801.2l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.4h-.05c-.34,1.5-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.19-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M323.58,794.15c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM314.65,796.61c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M332.51,784.15l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-2.99,0-.57.09-1.25.2-1.8l2.5-12.51h1.99ZM329.99,796.71c-.08.39-.15.85-.14,1.47.01,1.11.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.21-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M342.41,801.2l2.22-11.61h1.99l-2.22,11.61h-1.99ZM345,786.35c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.03.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M350.34,801.2l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M366.62,800.53c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM364.42,790.87c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='696.21 744.69 696.32 749.01 700.87 749.01 696.39 751.68 696.49 756.01 693.62 753.33 689.14 756.01 691.84 751.68 688.96 749.01 693.51 749.01 696.21 744.69'
				className='shape'
			/>
			<rect x='606.75' y='728.57' width='86.21' height='20' fill='none' className='shape' />
			<path
				d='M610.53,729.65c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.17,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM609.81,743.96c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M636.78,738.57c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM627.86,741.03c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M645.79,730.89l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M650.53,745.62l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M673.47,745.62c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM674.76,735.49c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M680.77,745.62l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
		</svg>
	);
};

AlabamaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default AlabamaMap;
